// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"930":"8be6d294","7211":"e6f535bc","9668":"e6f535bc"}[chunkId] + ".chunk.css";
};